// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3odwp","footer":"ReportModalFilter_footer__3p-Pv"};